export default "__VITE_ASSET__CsKFhi_E__"